module.exports = __webpack_public_path__ + "static/media/108.08615e3a.jpg";